import { render, staticRenderFns } from "./MedicionFrecuenciaPagination.vue?vue&type=template&id=900ae47c&"
import script from "./MedicionFrecuenciaPagination.vue?vue&type=script&lang=js&"
export * from "./MedicionFrecuenciaPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports